/**
 * What a user without a feature sees at the feature's address: a "no access" card, never the 404 (patterns.md K4;
 * CU-869fcezdm). The menu is not this file's business — `Layout` already hides a section whose `featuresV2[id]` is
 * falsy, so the entries stay hidden exactly as before; only the typed URL changes what it shows.
 */

export const ASK_LINE = 'Ask your account manager for access.'

/**
 * The words of the card. `moved`: the screen was retired and its replacement (a node the component renders right
 * after `intro`) is where it lives now; otherwise the feature is simply not enabled for the account.
 */
export function noAccessCopy({ name, moved = false }) {
	if (moved) return { subtitle: 'Moved', title: `${name} has moved`, intro: `${name} has been replaced by` }
	return { subtitle: 'No access', title: `${name} is not enabled for your account`, intro: `${name} is not part of your plan yet.` }
}

/** A route that is served but never listed. */
export const hiddenRoute = (path, element) => ({ path, element, noMenu: true })

/**
 * The children of a gated section while its flag is off: one catch-all, hidden, so every address under the section
 * (its index, a screen, a stale bookmark) shows `element` instead of falling through to the 404.
 */
export const noAccessChildren = element => [hiddenRoute('*', element)]
